import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faPlus } from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@campaignhub/react-hooks'

import Box from '../../Box'
import Text from '../../Text'

const toggleOpen = (expanded, setState, toggleCallbackFn) => {
  const newExpandedValue = !expanded

  setState({ expanded: newExpandedValue })

  if (toggleCallbackFn) toggleCallbackFn(newExpandedValue)
}

const defaultState = {
  expanded: false,
}

const ExpandableSectionBox = (props) => {
  const { boxProps, callbacks: { toggle: toggleFn }, children, contentBoxProps, defaultOpen, headerBoxProps, label } = props

  const [state, setState] = useSetState(defaultState)
  const { expanded } = state

  useEffect(() => setState({ expanded: defaultOpen }), [defaultOpen])

  return (
    <>
      <Box
        backgroundColor={expanded ? 'backgroundColor' : 'white'}
        borderBottom="1px solid"
        borderColor="lineColor"
        flexDirection="column"
        flexShrink="0"
        {...boxProps}
      >
        {/* Label/Header */}
        <Box
          alignItems="center"
          justifyContent="space-between"
          onClick={() => toggleOpen(expanded, setState, toggleFn)}
          padding="large"
          style={{ cursor: 'pointer' }}
          {...headerBoxProps}
        >
          <Text
            color={expanded ? 'bodyFontColor' : 'bodyFontLightColor'}
            fontSize="xsmall"
            fontWeight="500"
            letterSpacing="0.5px"
          >
            {label}
          </Text>

          <Text color={expanded ? 'bodyFontLightColor' : 'lightGrey'}>
            <FontAwesomeIcon icon={expanded ? faAngleDown : faPlus} />
          </Text>
        </Box>
        {/* End Label/Header */}

        {/* Content */}
        {expanded && (
          <Box flexDirection="column" padding="large" paddingTop="0" {...contentBoxProps}>
            {children}
          </Box>
        )}
        {/* End Content */}
      </Box>
    </>
  )
}

ExpandableSectionBox.propTypes = {
  callbacks: PropTypes.shape({
    toggleBox: PropTypes.func,
  }),
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  label: PropTypes.string,
  style: PropTypes.object,
}

ExpandableSectionBox.defaultProps = {
  callbacks: {},
  defaultOpen: false,
}

export default ExpandableSectionBox
